// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"457":"3ae0d580","488":"c72cb219","551":"7cdaf50e","851":"a3992c84"}[chunkId] + ".chunk.js";
};